import { render, staticRenderFns } from "./BuildIndividualContacts.vue?vue&type=template&id=6ad66e18&scoped=true"
import script from "./BuildIndividualContacts.vue?vue&type=script&lang=js"
export * from "./BuildIndividualContacts.vue?vue&type=script&lang=js"
import style0 from "./BuildIndividualContacts.vue?vue&type=style&index=0&id=6ad66e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad66e18",
  null
  
)

export default component.exports